import { render, staticRenderFns } from "./EndorsementContractDriver.vue?vue&type=template&id=b2fd8bbc"
import script from "./EndorsementContractDriver.vue?vue&type=script&lang=js"
export * from "./EndorsementContractDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports